module.exports = __webpack_public_path__ + "assets/computer.png";